"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.test = exports.keys = exports.includes = void 0;
// Array.includes
if (!Array.prototype.includes) {
    Array.prototype.includes = function (searchElement /*, fromIndex*/) {
        ('use strict');
        const O = Object(this);
        const len = parseInt(O.length, 10) || 0;
        if (len === 0) {
            return false;
        }
        // eslint-disable-next-line prefer-rest-params
        const n = parseInt(arguments[1], 10) || 0;
        let k;
        if (n >= 0) {
            k = n;
        }
        else {
            k = len + n;
            if (k < 0) {
                k = 0;
            }
        }
        let currentElement;
        while (k < len) {
            currentElement = O[k];
            if (searchElement === currentElement || (searchElement !== searchElement && currentElement !== currentElement)) {
                // NaN !== NaN
                return true;
            }
            k++;
        }
        return false;
    };
}
// Object.keys
if (!Object.keys) {
    // tslint:disable-next-line: only-arrow-functions
    Object.keys = (function () {
        ('use strict');
        const hasOwnProperty = Object.prototype.hasOwnProperty;
        // eslint-disable-next-line no-prototype-builtins
        const hasDontEnumBug = !{ toString: null }.propertyIsEnumerable('toString');
        const dontEnums = [
            'toString',
            'toLocaleString',
            'valueOf',
            'hasOwnProperty',
            'isPrototypeOf',
            'propertyIsEnumerable',
            'constructor'
        ];
        const dontEnumsLength = dontEnums.length;
        // tslint:disable-next-line: only-arrow-functions
        return function (obj) {
            if (typeof obj !== 'function' && (typeof obj !== 'object' || obj === null)) {
                throw new TypeError('Object.keys called on non-object');
            }
            const result = [];
            let prop;
            let i;
            for (prop in obj) {
                if (hasOwnProperty.call(obj, prop)) {
                    result.push(prop);
                }
            }
            if (hasDontEnumBug) {
                for (i = 0; i < dontEnumsLength; i++) {
                    if (hasOwnProperty.call(obj, dontEnums[i])) {
                        result.push(dontEnums[i]);
                    }
                }
            }
            return result;
        };
    })();
}
// Object.assign
if (typeof Object.assign !== 'function') {
    // tslint:disable-next-line: only-arrow-functions
    Object.assign = function (target /*, varArgs: any*/) {
        // .length of function is 2
        ('use strict');
        if (target == null) {
            // TypeError if undefined or null
            throw new TypeError('Cannot convert undefined or null to object');
        }
        const to = Object(target);
        for (let index = 1; index < arguments.length; index++) {
            // eslint-disable-next-line prefer-rest-params
            const nextSource = arguments[index];
            if (nextSource != null) {
                // Skip over if undefined or null
                for (const nextKey in nextSource) {
                    // Avoid bugs when hasOwnProperty is shadowed
                    if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                        to[nextKey] = nextSource[nextKey];
                    }
                }
            }
        }
        return to;
    };
}
// test polyfill
// @ts-ignore
if (!Array.test) {
    // @ts-ignore
    // tslint:disable-next-line: only-arrow-functions
    Array.test = function () {
        return 'test';
    };
}
exports.includes = Array.prototype.includes;
exports.keys = Object.keys;
// @ts-ignore
exports.test = Array.test;
//# sourceMappingURL=polyfills.js.map